"use strict";
String.prototype.isEmpty = function () {
    return this === '';
};
//# sourceMappingURL=string.js.map